'use strict';

var cov_17h2bmwnp7 = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/StylingConstants/lib/index.js',
      hash = '7dce748305761435ec9224978f3b379a1716dcc1',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/StylingConstants/lib/index.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 14
        },
        end: {
          line: 35,
          column: 1
        }
      },
      '1': {
        start: {
          line: 37,
          column: 15
        },
        end: {
          line: 44,
          column: 1
        }
      },
      '2': {
        start: {
          line: 46,
          column: 13
        },
        end: {
          line: 64,
          column: 1
        }
      },
      '3': {
        start: {
          line: 66,
          column: 16
        },
        end: {
          line: 74,
          column: 1
        }
      },
      '4': {
        start: {
          line: 76,
          column: 12
        },
        end: {
          line: 79,
          column: 1
        }
      },
      '5': {
        start: {
          line: 81,
          column: 14
        },
        end: {
          line: 85,
          column: 1
        }
      },
      '6': {
        start: {
          line: 87,
          column: 21
        },
        end: {
          line: 90,
          column: 1
        }
      },
      '7': {
        start: {
          line: 93,
          column: 21
        },
        end: {
          line: 101,
          column: 6
        }
      },
      '8': {
        start: {
          line: 94,
          column: 2
        },
        end: {
          line: 98,
          column: 4
        }
      },
      '9': {
        start: {
          line: 94,
          column: 28
        },
        end: {
          line: 98,
          column: 3
        }
      },
      '10': {
        start: {
          line: 100,
          column: 2
        },
        end: {
          line: 100,
          column: 13
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 93,
            column: 47
          },
          end: {
            line: 93,
            column: 48
          }
        },
        loc: {
          start: {
            line: 93,
            column: 63
          },
          end: {
            line: 101,
            column: 1
          }
        },
        line: 93
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 94,
            column: 15
          },
          end: {
            line: 94,
            column: 16
          }
        },
        loc: {
          start: {
            line: 94,
            column: 28
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 94
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0
    },
    f: {
      '0': 0,
      '1': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n    @media (min-width: ', 'em) {\n      ', ';\n    }\n  '], ['\n    @media (min-width: ', 'em) {\n      ', ';\n    }\n  ']);

var _styledComponents = require('styled-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var color = (cov_17h2bmwnp7.s[0]++, {
  // To be used for common text, link, titles, etc..
  baseText: '#3b3d40',
  baseBackground: '#fff',
  darkBackground: '#333333',
  baseSubTitle: '#838c91',
  // To be used for buttons
  transparent: 'transparent',
  boxText: '#fff',
  boxBackground: '#1a84f1',
  disabledBackground: '#e0e0e0',
  disabledText: '#c0c0c0',
  disabledBackdrop: 'rgba(0, 0, 0, 0.1)',
  // To be used for borders and shadows
  greyLighter: '#F5F5F5',
  greyLight: '#D3D3D3',
  grey: '#808080',
  greyDark: '#A9A9A9',
  greyDarker: '#676f7e',
  // default info
  info: '#75cdf8',
  positive: '#81dca7',
  notice: '#f8cf7e',
  warning: '#ff8c57',
  negative: '#ff4747',
  // add for indicator (copy paste of positive, warning and negative)
  NONE: '#FF0000',
  LIMITED: '#FF9900',
  GOOD: '#339966',
  // disabling backdrop on an element
  backdrop: 'rgba(255, 255, 255, 0.7)',
  SOLD_OUT: '#3e3e3e'
});

var border = (cov_17h2bmwnp7.s[1]++, {
  // the common border size
  widthBase: '0.0625rem',
  // No radius
  radiusNone: 0,
  radiusBase: '0.75rem',
  radiusSmall: '0.15rem'
});

var font = (cov_17h2bmwnp7.s[2]++, {
  // Size of text
  sizeXxxxl: '3rem',
  sizeXxxl: '2.5rem',
  sizeXxl: '2rem',
  sizeXl: '1.6rem',
  sizeMl: '1.4rem',
  sizeL: '1.2rem',
  sizeM: '1rem',
  sizeMS: '0.875rem',
  sizeS: '0.8rem',
  sizeXs: '0.75rem',
  sizeXxs: '0.6rem',
  sizeXxxs: '0.5rem',
  weightLight: '300',
  weightRegular: '400',
  weightSemibold: '500',
  weightBold: '700'
});

var spacing = (cov_17h2bmwnp7.s[3]++, {
  xxsmall: '0.125rem',
  xsmall: '0.25rem',
  small: '0.5rem',
  medium: '1rem',
  large: '1.5rem',
  xlarge: '2rem',
  xxlarge: '4rem'
});

var url = (cov_17h2bmwnp7.s[4]++, {
  favicon: 'data:image/x-icon;base64,AAABAAEAEBAQAAAAAAAoAQAAFgAAACgAAAAQAAAAIAAAAAEABAAAAAAAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAACAAAAAgIAAgAAAAIAAgACAgAAAwMDAAICAgAAAAP8AAP8AAAD//wD/AAAA/wD/AP//AAD///8A//////////////////////+ZmZmZmZmf/5mZmZmZmZ//mZmZmZmZn/+ZmZmZmZmf/5mZmZmZmZ//mZmZmZmZn/+ZmZmZmZmf/5mZmZmZmZ//mZmZmZmZn/+ZmZmZmZmf//mZmZmZmZ//+ZmZmZmZn////3g5mZmf//////////8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'
});

var sizes = (cov_17h2bmwnp7.s[5]++, {
  desktop: 1024,
  tablet: 768,
  phone: 320
});

var indentLevels = (cov_17h2bmwnp7.s[6]++, {
  1: '25px',
  2: '50px'

  // Iterate through the sizes and create a media template
});var mediaQueries = (cov_17h2bmwnp7.s[7]++, (0, _keys2.default)(sizes).reduce(function (acc, label) {
  cov_17h2bmwnp7.f[0]++;
  cov_17h2bmwnp7.s[8]++;

  acc[label] = function () {
    cov_17h2bmwnp7.f[1]++;
    cov_17h2bmwnp7.s[9]++;
    return (0, _styledComponents.css)(_templateObject, sizes[label] / 16, _styledComponents.css.apply(undefined, arguments));
  };

  cov_17h2bmwnp7.s[10]++;
  return acc;
}, {}));

exports.default = { border: border, color: color, font: font, spacing: spacing, url: url, mediaQueries: mediaQueries, indentLevels: indentLevels, sizes: sizes };